import axios from 'axios';
import { verifyEnvUrl } from 'util/verifyEnvUrl';

const PROD_URL = 'https://api.acordofechado.com.br/whatsapp-oficial';
const DEV_URL = 'https://api.acordofechado.com.br/whatsapp-oficial-dev';

const whatsAppOficialApi = axios.create( {
	baseURL: verifyEnvUrl( PROD_URL, DEV_URL ),
} );

whatsAppOficialApi.interceptors.request.use( async config => {
	const token = localStorage.getItem( 'af-token' );
	if ( token ) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
} );

export default whatsAppOficialApi;
